import { render, staticRenderFns } from "./LiveChatTree.vue?vue&type=template&id=0b640d68&scoped=true&"
import script from "./LiveChatTree.vue?vue&type=script&lang=js&"
export * from "./LiveChatTree.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatTree.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiveChatTree.vue?vue&type=style&index=1&id=0b640d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b640d68",
  null
  
)

export default component.exports